/* tslint:disable */
/* eslint-disable */
/**
 * AMJ Accounts Service REST API
 * Maintain AMJ Accounts data
 *
 * The version of the OpenAPI document: 1.0
 * Contact: mail@fidrees.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * UserSettingsControllerApi - axios parameter creator
 * @export
 */
export const UserSettingsControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {DeleteUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSettings: (settingName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'settingName' is not null or undefined
            assertParamExists('deleteUserSettings', 'settingName', settingName);
            const localVarPath = `/api/user-settings/{settingName}`
                .replace(`{${"settingName"}}`, encodeURIComponent(String(settingName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserSettings: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings: (settingName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'settingName' is not null or undefined
            assertParamExists('getUserSettings', 'settingName', settingName);
            const localVarPath = `/api/user-settings/{settingName}`
                .replace(`{${"settingName"}}`, encodeURIComponent(String(settingName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UserSettingsDto} userSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings: (userSettingsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userSettingsDto' is not null or undefined
            assertParamExists('saveUserSettings', 'userSettingsDto', userSettingsDto);
            const localVarPath = `/api/user-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userSettingsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserSettingsControllerApi - functional programming interface
 * @export
 */
export const UserSettingsControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserSettingsControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {DeleteUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSettings(settingName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserSettings(settingName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserSettingsControllerApi.deleteUserSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserSettings(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUserSettings(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserSettingsControllerApi.getAllUserSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {GetUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(settingName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserSettings(settingName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserSettingsControllerApi.getUserSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {UserSettingsDto} userSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings(userSettingsDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveUserSettings(userSettingsDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['UserSettingsControllerApi.saveUserSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * UserSettingsControllerApi - factory interface
 * @export
 */
export const UserSettingsControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserSettingsControllerApiFp(configuration);
    return {
        /**
         *
         * @param {DeleteUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserSettings(settingName, options) {
            return localVarFp.deleteUserSettings(settingName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserSettings(options) {
            return localVarFp.getAllUserSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetUserSettingsSettingNameEnum} settingName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSettings(settingName, options) {
            return localVarFp.getUserSettings(settingName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserSettingsDto} userSettingsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserSettings(userSettingsDto, options) {
            return localVarFp.saveUserSettings(userSettingsDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserSettingsControllerApi - object-oriented interface
 * @export
 * @class UserSettingsControllerApi
 * @extends {BaseAPI}
 */
export class UserSettingsControllerApi extends BaseAPI {
    /**
     *
     * @param {DeleteUserSettingsSettingNameEnum} settingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsControllerApi
     */
    deleteUserSettings(settingName, options) {
        return UserSettingsControllerApiFp(this.configuration).deleteUserSettings(settingName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsControllerApi
     */
    getAllUserSettings(options) {
        return UserSettingsControllerApiFp(this.configuration).getAllUserSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GetUserSettingsSettingNameEnum} settingName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsControllerApi
     */
    getUserSettings(settingName, options) {
        return UserSettingsControllerApiFp(this.configuration).getUserSettings(settingName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserSettingsDto} userSettingsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSettingsControllerApi
     */
    saveUserSettings(userSettingsDto, options) {
        return UserSettingsControllerApiFp(this.configuration).saveUserSettings(userSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const DeleteUserSettingsSettingNameEnum = {
    SummaryOrder: 'SUMMARY_ORDER'
};
/**
 * @export
 */
export const GetUserSettingsSettingNameEnum = {
    SummaryOrder: 'SUMMARY_ORDER'
};
